import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, CircularProgress } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { MongoAbility, AbilityTuple, MongoQuery } from "@casl/ability";
import { theme as themeDefinition } from "./theme";
import { AbilityContext } from "../../permission/Can";
import { RootState } from "../../state";
import MenuBar from "../MenuBar/MenuBar";
import Dialog from "../Dialog/Dialog";
import Notification from "../Notification/Notification";
import BackdropLoader from "../BackdropLoader/BackdropLoader";
import defineAbilityFor from "../../permission/defineAbility";
import Footer from "../Footer/Footer";
import settings from "../../config/settings";
import "../../styles/globals.css";
import "./Bootstrap.css";

export interface BootstrapProps {
  children: any;
}

const Bootstrap = (props: BootstrapProps) => {
  // General Declarations -----------------------------------------------------
  const { children } = props;
  const Component = children.type;

  const loginData = useSelector((state: RootState) => state.login);

  const [ability, setAbility] = useState<
    MongoAbility<AbilityTuple, MongoQuery> | undefined
  >(undefined);
  useEffect(() => {
    setAbility(defineAbilityFor(loginData));
  }, []);

  useEffect(() => {
    setAbility(defineAbilityFor(loginData));
  }, [loginData]);

  return ability !== undefined ? (
    <AbilityContext.Provider value={ability}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
        <GoogleOAuthProvider clientId={settings.google_client_id}>
          <ThemeProvider theme={themeDefinition} aria-label>
            <MenuBar />
            <Component {...children.params} />
            <Footer />
            <BackdropLoader />
            <Dialog />
            <Notification />
          </ThemeProvider>
        </GoogleOAuthProvider>
      </LocalizationProvider>
    </AbilityContext.Provider>
  ) : (
    <Grid container alignItems={"center"}>
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};

export default Bootstrap;
